var map = {
	"./bg_color.svg": 304,
	"./bright_contrast.svg": 305,
	"./contrast.svg": 306,
	"./cursorBlack.svg": 307,
	"./cursorWhite.svg": 308,
	"./dark_contrast.svg": 309,
	"./focus_window.svg": 310,
	"./fontSize.svg": 311,
	"./height_saturation.svg": 312,
	"./highlight_headers.svg": 313,
	"./highlight_link.svg": 314,
	"./low_saturation.svg": 315,
	"./monochrome.svg": 316,
	"./spacing.svg": 317,
	"./text_color.svg": 318,
	"./zoom.svg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;